import axios from 'axios';
const axiosInstance = () => {
    const instance = axios.create({
        baseURL: 'https://api.overseasedops.com/api/v1/'
        // baseURL: 'http://localhost:8080/api/v1/',
    });

    instance.interceptors.request.use(
        (config) => {
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return instance;
};

export default axiosInstance;